module.exports = __webpack_public_path__ + "static/img/53b8d6afdeef5.7abc1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/53b8d6afdeef5.jpg
// module id = +ksc
// module chunks = 0